import * as styles from "./MonthPickerArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import { useMonthPickerContext } from "./MonthPicker.context";
import type { MonthPickerArrowProps } from "./MonthPicker.types";

export function MonthPickerArrow({
  className,
  style,
  ...props
}: MonthPickerArrowProps): JSX.Element {
  const { size } = useMonthPickerContext();

  return (
    <BasePopover.Arrow
      data-slot="month-picker-arrow"
      className={clsx(styles.arrow({ size }), className)}
      style={{ left: "50%", transform: "translateX(-50%)", ...style }}
      {...props}
    />
  );
}
